/** Keys written by legacy auth code — cleared on logout without wiping unrelated app data */
const LEGACY_AUTH_KEYS = ['user', 'userId', 'token'];

const SESSION_AUTH_KEYS = ['user', 'userId', 'token'];

/**
 * Clear authentication state from browser storage.
 * Preserves non-auth keys (e.g. cubegames_recent).
 */
export function clearAuthStorage() {
  localStorage.removeItem('persist:root');
  LEGACY_AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
  SESSION_AUTH_KEYS.forEach((key) => sessionStorage.removeItem(key));
}
